<!--
 * 头部组件
 * @author 滕威
 * @time 2019-12-05
 *
-->
<!-- VUE模板(html)代码 start -->
<template>
  <div class="header">
    <div class="left">
      <div class="logo_wrap">
        <img src="../../../assets/images/login/logo.png" alt="" />
        <span>武汉市房屋建筑工程招标投标监督管理系统</span>
      </div>
    </div>
    <div class="right">
       <el-tooltip class="item" popper-class="popper" effect="light" placement="bottom" v-if="((flag == '' || flag == null) && userFlag != '工作人员' && userFlag !== '监管人员') && !registryFlag">
        <div slot="content" class="content">
          <p @click="fun_UserSwitchover('201904241041160002')"><img src="@/assets/images/tenderer_tab_icon.png"><span>招标人/采购单位</span></p>
          <p @click="fun_UserSwitchover('201904241343420001')"><img src="@/assets/images/bidder_tab_icon.png"><span>投标人/供应商</span></p>
          <p @click="fun_UserSwitchover('201904241346560059')"><img src="@/assets/images/agent_tab_icon.png"><span>招标代理/采购代理</span></p>
        </div>
        <el-button class="switchover right-left" icon="el-icon-qiehuan">切换主体类型登录<i class="el-icon-caret-bottom"></i></el-button>
      </el-tooltip>
      <div class="size">
        <span>文本缩放：</span>
        <span class="s" @click="fun_Zoomout"><i class="el-icon-plus"></i></span>
        <span class="si">{{ Math.floor(size * 100) }}%</span>
        <span class="s" @click="fun_Zoomin"><i class="el-icon-minus"></i></span>
      </div>
      <div class="reg right-left" @click="fun_ShowHomePage('1')" v-if="(flag == '' || flag == null) && !registryFlag">
        <i class="el-icon-shouye"></i>
        <span>首页</span>
      </div>
      <div class="reg right-left" v-if="userFlag === '监管人员'" @click="fun_DataStatistics">
        <img src="@/assets//images/workbench//dataStatisticsIcon.png" alt="">
        <span>数据统计</span>
      </div>
      <div class="reg right-left" @click="fun_MsgMessagBoard" v-if="((flag == '' || flag == null) && userFlag != '工作人员' && userFlag !== '监管人员') && !registryFlag">
        <i class="el-icon-yijianfankui"></i>
        <span>意见反馈</span>
      </div>
      <div class="reg right-left" @click="fun_UserReg" v-if="((flag == '' || flag == null) && userFlag != '工作人员' && userFlag !== '监管人员') && !registryFlag">
        <i class="el-icon-yonghuzhuce"></i>
        <span>用户注册</span>
      </div>
      <el-tooltip class="item" popper-class="popper" effect="light" placement="bottom">
        <div slot="content" class="content">
          <span @click="fun_PasswordUpdate" v-if="(flag == '' || flag == null) && userFlag != '工作人员'">修改密码</span>
          <span @click="fun_LoginOut">退出登录</span>
        </div>
        <el-button icon="el-icon-user-solid" v-if="userFlag === '工作人员' || registryFlag">
          {{ userInfo.realName }}<i class="el-icon-arrow-down"></i>
        </el-button>
        <el-button icon="el-icon-user-solid" v-else>
          {{ loginType ? loginType : "欢迎您" }}：{{ userInfo.realName.length > 20 ? userInfo.realName.substring(0, 20) + "..." : userInfo.realName }}<i class="el-icon-arrow-down"></i>
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>
<!-- VUE模板(html)代码 end -->

<!-- JS代码 start -->
<script>
/*
 * 导入axios接口
 * 登录：login
 * @author 滕威
 */
import { fun_GetAction } from "@/api";
import { mapState } from "vuex";
import { Loading } from "element-ui";
import Layout from "../Home.vue";
import router from "../../../router/router";
import { supervisionRouteMap } from "../../../router/index";
import store from "../../../store";
import VueRouter from 'vue-router';
/**
 * 导入加密组件
 * @author 滕威
 */
export default {
  inject: ["reload"],
  data() {
    return {
      loginType: null, // 登录身份
      flag: null,// 判断显示菜单
      mmfzd: null,// 密码复杂度
      noPageflag: null,// 登录信息更新标志
      supervisionInformFlag: false,// 进入监管通知页面
      regPasswordUpdateFlag: false,// 进入修改密码界面（注册人）
      regSmPasswordUpdateFlag: false,// 进入修改密码界面（注册人-扫码）
      corpPasswordUpdateFlag: false,// 进入修改密码界面（企业）
      corpSmPasswordUpdateFlag: false,// 进入修改密码界面（企业-扫码）
      supervisionFlag: false,// 监管页面标志
      corpFlag: false,// 进入交易人界面
      registryFlag: false,// 进入注册人界面
      fullLoading: null,  // 全局加载
      otherRouters: [],
      userFlag: null, // 用户类型
      userId: null, // 用户编号
      // 缩放比例
      size: 1,
    };
  },
  // 声明组件
  components: {

  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    // 添加对 sessionStorage 的监听
    window.addEventListener("setItem", () => {
      // 当sessionStorage 中的lang值发生变化， 给组件中的值重新赋值
      this.flag = sessionStorage.getItem("flag") ? sessionStorage.getItem("flag") : null;
      this.userFlag = sessionStorage.getItem("userFlag") ? sessionStorage.getItem("userFlag") : null;
    });
  },
  mounted() {
    // 如果不是工作人员登录
    if(sessionStorage.getItem("userFlag") != "工作人员" && sessionStorage.getItem("userFlag") != "监管人员"){
      // 如果是注册人员或者其他标室预定用户
      if(sessionStorage.getItem("userType") === "201508061647510026" || sessionStorage.getItem("userType") === "201806011403520002"){
        // 注册人员获取左侧菜单
        this.fun_RegistryFindMenu();
      }
      // 交易人
      else{
        // 首页跳转
        this.fun_ShowCorpHomePage();
      }
    }else{
      // 工作人员首页跳转
      this.fun_ShowSupervisorHomePage();
    }
  },
  /**
   * 自定义方法模块
   */
  methods: {
    /**
     * 数据统计
     */
    fun_DataStatistics(){
      // 跳转数据统计
      this.$router.push({path: "/projectDataStatistics" });
    },
    /**
     * 首页跳转
     * @param e
     */
    fun_ShowHomePage(e){
      // 如果不是工作人员登录
      if(sessionStorage.getItem("userFlag") != "工作人员" && sessionStorage.getItem("userFlag") != "监管人员"){
        // 如果是注册人员
        if(sessionStorage.getItem("userType") === "201508061647510026" || sessionStorage.getItem("userType") === "201806011403520002"){
          // 注册人员获取左侧菜单
          this.fun_RegistryFindMenu();
        }
        // 交易人
        else{
          // 首页跳转
          this.fun_ShowCorpHomePage();
        }
      }else{
        // 工作人员首页跳转
        this.fun_ShowSupervisorHomePage(e);
      }
    },
    /**
     * 工作人员首页
     */
    fun_ShowSupervisorHomePage(e){
      // 判断是工作人员、监管人员不再执行获取路由
      if(sessionStorage.getItem("userFlag") === "监管人员"){
        // 重新加载菜单栏
        fun_GetAction("/supervisorPower/supervisorFindMenu").then(res => {
          const { result, data } = res.data;
          if (result) {
            // 更新路由
            store.commit("SET_ROUTER", data.router); // 存储路由到vuex
            // 清空存储
            sessionStorage.setItem("workbenchMenu", "");
            this.routerGo(data.router);
            this.reload();
            // 如果是招标监管管理人员或者系统管理员
            if((sessionStorage.getItem("userType") === "202506260600100001" || sessionStorage.getItem("userType") === "201509211144060142") && !e){
              // 打开数据统计
              this.fun_DataStatistics();
            }else{
              // 跳转工作台
              this.$router.push({path: "/staffWorkbench" });
            }
          }
        });
      }
      else if(sessionStorage.getItem("userFlag") === "工作人员"){
        // 跳转工作台
        this.$router.push({path: "/home" });
        return;
      }
    },
    /**
     * 企业首页跳转
     * @param e
     */
    fun_ShowCorpHomePage(){
      // 遮罩框加载
      this.fun_Loading();
      // 重新加载左侧菜单
      this.fun_RegistryFindPower(sessionStorage.getItem("loginType"));
    },
    /**
     * 切换交易主体
     * @param e
     */
    fun_UserSwitchover(e){
      // 遮罩框加载
      this.fun_Loading();
      // 重新加载左侧菜单
      this.fun_RegistryFindPower(e);
    },
    /**
     * 前台注册用户登录权限
     * @param e
     */
    fun_RegistryFindPower(e){
      // 设置用户身份
      this.fun_SetLoginType(e);
      // 调用登录接口
      fun_GetAction("/findPower/registryFindPower?type=" + e).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断接口参数result
        if (result) {
          this.mmfzd = data.mmfzd;// 密码复杂度
          this.noPageflag = data.noPageflag;// 登录信息更新标志
          this.supervisionInformFlag = data.supervisionInformFlag;// 进入监管通知页面
          this.regPasswordUpdateFlag = data.regPasswordUpdateFlag;// 进入修改密码界面（注册人）
          this.regSmPasswordUpdateFlag = data.regSmPasswordUpdateFlag;// 进入修改密码界面（注册人-扫码）
          this.corpPasswordUpdateFlag = data.corpPasswordUpdateFlag;// 进入修改密码界面（企业）
          this.corpSmPasswordUpdateFlag = data.corpSmPasswordUpdateFlag;// 进入修改密码界面（企业-扫码）
          this.supervisionFlag = data.supervisionFlag;// 监管页面标志
          this.corpFlag = data.corpFlag;// 进入交易人界面
          this.registryFlag = data.registryFlag;// 进入注册人界面
          this.userId = data.userId;// 用户编号
          // 重新加载左侧菜单
          this.fun_OperationFindMenu(e);
          // 如果当前页面在工作台
          if (this.$route.path === "/home") {
            // 重新请求工作台接口
            // 传递标识参数
            this.$store.commit("SET_QUERYHOME", Math.random() * 10)
          }
        }
      });
    },
    /**
     * 重新加载左侧菜单
     */
    fun_OperationFindMenu(e){
      fun_GetAction("/findPower/operationFindMenu?type=" + e).then(res => {
        const { result, data } = res.data;
        if (result) {
          // 更新路由
          this.$store.commit("SET_ROUTER", data.router); // 存储路由到vuex
          // 清空存储
          sessionStorage.setItem("workbenchMenu", "");
          this.routerGo(data.router);
          this.reload();
          // 跳转页面
          this.fun_SkipPage();
        }
      });
    },
    /**
     * 跳转页面
     */
    fun_SkipPage(){
      // 进入监管通知页面
      if(this.supervisionInformFlag){
        // 跳往监管通知页面
        this.$router.push({ path: "/supervisionInform" });
        // 加载框取消
        this.fullLoading.close();
        return false;
      }
      // 进入修改密码界面（注册人）
      else if(this.supervisionInformFlag){
        // 全局存储
        this.resetSetItem("flag", "1");
        // 跳往修改密码界面（注册人）
        this.$router.push({ path: "/loginPassword" });
        // 加载框取消
        this.fullLoading.close();
        return false;
      }
      // 进入修改密码界面（企业）
      else if(this.corpPasswordUpdateFlag){
        // 全局存储
        this.resetSetItem("flag", "1");
        // 跳往监管通知页面
        this.$router.push({ path: "/loginPassword" });
        // 加载框取消
        this.fullLoading.close();
        return false;
      }
      // 进入监管页面标志
      else if(this.supervisionFlag){

        // 加载框取消
        this.fullLoading.close();
        return false;
      }
      // 进入注册人页面
      else if(this.registryFlag){
        // 注册人员获取左侧菜单
        this.fun_RegistryFindMenu();
        // 加载框取消
        this.fullLoading.close();
        return false;
      }
      // 进入交易人界面
      else if(this.corpFlag){
        // 全局存储
        // this.resetSetItem("flag", "1");
        // 跳转工作台
        this.$router.push({path: "/home"});
        // 加载框取消
        this.fullLoading.close();
        return false;
      }else{
        // 跳转工作台
        this.$router.push({path: "/home"});
        // 加载框取消
        this.fullLoading.close();
        return false;
      }
    },

    /**
     * 注册人重新加载左侧菜单
     */
    fun_RegistryFindMenu(){
      fun_GetAction("/findPower/registryFindMenu").then(res => {
        const { result, data } = res.data;
        if (result) {
          // 设置为注册人
          this.registryFlag = true;
          // 更新路由
          this.$store.commit("SET_ROUTER", data.opList); // 存储路由到vuex
          // 清空存储
          sessionStorage.setItem("workbenchMenu", "");
          this.routerGo(data.opList);
          this.reload();
        }
      });
    },
    /**
     * 设置用户身份
     */
    fun_SetLoginType(e){
      // 交易人（企业）
      if (e === "201508061647340018") {
        // 招标人
        sessionStorage.setItem("loginType", "201904241041160002");
      } else {
        // 重新设置登录角色
        sessionStorage.setItem("loginType", e);
      }
      // 重新设置登录角色
      switch (e) {
        case "201904241343420001":
          this.loginType = "投标人";
          break;
        case "201904241346560059":
          this.loginType = "招标代理";
          break;
        case "201904241041160002":
          this.loginType = "招标人";
          break;
        default:
          this.loginType = "招标人";
      }
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    routerGo(routerJson) {
      this.filterOtherRouter(routerJson);
      let asyncRouters = this.filterAsyncRouter(routerJson);
      const errorRouter = [
        {
          path: "/404",
          name: "exception404",
          component: () => import("../../../components/exception/404")
        },
        {
          path: "/403",
          name: "exception403",
          component: () => import("../../../components/exception/403")
        },
        {
          path: "/500",
          name: "exception500",
          component: () => import("../../../components/exception/500")
        }
      ];
      const localouter = [
        // 工作台详情
        {
          path: "/workbenchDetails",
          name: "workbenchDetails",
          component: () => import("../../../views/page/workbench/details/index.vue")
        },
        // 修改密码
        {
          path: "/password",
          name: "password",
          component: () => import("../../../views/page/userRegister/updatePassword/index.vue")
        },
        // 修改密码
        {
          path: "/loginPassword",
          name: "loginPassword",
          component: () => import("../../../views/page/corpView/loginPassword/index.vue")
        },
        // 交易人 - 用户注册模块
        {
          path: "/userRegister",
          name: "userRegister",
          component: () => import("../../../views/page/userRegister/index.vue")
        },
        // 网上CA资料申报信息
        {
          path: "/userDeclare",
          name: "userDeclare",
          component: () => import("../../../views/page/userRegister/declare/index.vue")
        },
        // 企业登记详情
        {
          path: "/corpRegistrationDetails",
          name: "corpRegistrationDetails",
          component: () => import("../../../views/page/userRegister/corpRegistration/details/index.vue")
        },
        // 消息提醒
        {
          path: "/workbenchMore",
          name: "workbenchMore",
          component: () => import("../../../views/page/workbench/components/more/index.vue")
        },
        // 设置注册人转入
        {
          path: "/regPersonBasicinfoUnCorpChoose",
          name: "regPersonBasicinfoUnCorpChoose",
          component: () => import("../../../views/page/userRegister/regPersonBasicinfo/unCorpChoose/index.vue")
        },
      ];
      if(sessionStorage.getItem("userFlag") === "监管人员") localouter.push(...supervisionRouteMap);
      const homeRouter = [
        {
          path: "/home",
          name: "home", 
          component: () => import("../../../views/layout/Home"),
          // redirect: { path: "/userManage" },
          children: [...this.otherRouters, ...localouter, ...errorRouter]
        }
      ];
      // router.addRoutes([...homeRouter,...asyncRouters]); //动态添加路由
      // router.addRoutes(asyncRouters); //动态添加路由
      router.matcher = new VueRouter({
        routes: [...homeRouter,...asyncRouters]
      }).matcher
      global.antRouter = asyncRouters; //将路由数据传递给全局变量，做侧边栏菜单渲染工作
    },

    filterAsyncRouter(asyncRouterMap) {
      //遍历后台传来的路由字符串，转换为组件对象
      const accessedRouters = asyncRouterMap.filter(route => {
        if (route.component) {
          if (route.component === "Layout") {
            //Layout组件特殊处理
            route.component = Layout;
          } else {
            route.component = this.componentImport(route.component);
          }
        }
        if (route.children && route.children.length) {
          route.children = this.filterAsyncRouter(route.children);
        }
        return true;
      });
      return accessedRouters;
    },

    filterOtherRouter(asyncRouterMap) {
      for (let i in asyncRouterMap) {
        let otherRouter = {};
        if (asyncRouterMap[i].component) {
          if (asyncRouterMap[i].component === "Layout") {
            //Layout组件特殊处理
          } else {
            otherRouter.name = asyncRouterMap[i].name.replace(
                asyncRouterMap[i].name,
                asyncRouterMap[i].name + "Detail"
            );
            otherRouter.path = asyncRouterMap[i].path.replace(
                asyncRouterMap[i].path,
                asyncRouterMap[i].path + "Detail"
            );
            otherRouter.meta = {};
            if (asyncRouterMap[i].title != "") {
              otherRouter.title = asyncRouterMap[i].title + "详情";
              otherRouter.component = this.componentImport(
                  asyncRouterMap[i].component.replace(
                      asyncRouterMap[i].path.replace("Ebd", ""),
                      asyncRouterMap[i].path.replace("Ebd", "") + "/details"
                  )
              );
            }
          }
        }
        if (otherRouter.name) {
          this.otherRouters.push(otherRouter);
        }
        if (asyncRouterMap[i].children && asyncRouterMap[i].children.length) {
          asyncRouterMap[i].children = this.filterOtherRouter(
              asyncRouterMap[i].children
          );
        }
      }
      return asyncRouterMap;
    },
    componentImport(component) {
      return () => import("../../../views/" + component);
    },
    /**
     * 跳转用户注册
     * @author 滕威
     */
    fun_UserReg() {
      fun_GetAction("/findPower/operationFindMenu?type=" + sessionStorage.getItem("loginType")).then(res => {
        const { result, data } = res.data;
        if (result) {
          // 更新路由
          this.$store.commit("SET_ROUTER", data.router); // 存储路由到vuex
          // 清空存储
          sessionStorage.setItem("workbenchMenu", "");
          this.routerGo(data.router);
          this.reload();
          // 跳转页面
          this.$router.push({ path: "/userRegister" });
        }
      });
    },
    /**
     * 跳转意见反馈
     * @author 滕威
     */
    fun_MsgMessagBoard(){
      fun_GetAction("/findPower/operationFindMenu?type=" + sessionStorage.getItem("loginType")).then(res => {
        const { result, data } = res.data;
        if (result) {
          // 更新路由
          this.$store.commit("SET_ROUTER", data.router); // 存储路由到vuex
          // 清空存储
          sessionStorage.setItem("workbenchMenu", "");
          this.routerGo(data.router);
          this.reload();
          // 跳转页面
          this.$router.push({ path: "/msgMessagBoard" });
        }
      });
    },
    /**
     * 跳转工作台
     * @author 滕威
     */
    fun_Workbench() {
      // 跳转
      this.$router.push({ path: "/home" });
    },
    /**
     * 修改密码
     * @author 滕威
     */
    fun_PasswordUpdate(){
      // 跳转
      this.$router.push({ path: "/password" });
    },
    /**
     * 退出登录方法
     * @author 滕威
     */
    fun_LoginOut() {
      // 询问框
      this.$confirm("您确定退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 调用登录接口
        fun_GetAction("/loginOut").then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断接口参数result
          if (result) {
            // 记录登录类型
            let loginType = sessionStorage.getItem("loginType");
            // 清空sessionStorage
            sessionStorage.clear();
            // 重置
            sessionStorage.setItem("loginType", loginType);
            var herf = window.location.href;
            // 截取
            var array = herf.substring(0, herf.indexOf("#") + 2);
            // 返回路径不为空
            if(data){
              // 跳转到登录页
              window.location.href = data;
            }else{
              // 跳转到登录页
              window.location.href = array;
              // 刷新页面
              window.location.reload()
            }
          } else {
            // 错误消息提示
            if (msg) this.$message.error(msg);
          }
        });
      });
    },
    /**
     * 设置比例
     * @author 滕威
     */
    fun_SetSize() {
      document.body.style.zoom = this.size;
      document.body.style.cssText +=
        "; -moz-transform: scale(" +
        this.size +
        ");-moz-transform-origin: 0 0; ";
    },
    /**
     * 放大比例调用
     * @author 滕威
     */
    fun_Zoomout() {
      this.size = this.size + 0.1;
      this.fun_SetSize();
    },
    /**
     * 缩小比例调用
     * @author 滕威
     */
    fun_Zoomin() {
      this.size = this.size - 0.1;
      this.fun_SetSize();
    },
  }
};
</script>
<!-- JS代码 end -->

<!-- css样式 start-->
<style lang="scss" scoped>
.header {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  display: -ms-flexbox;
  justify-content: space-between;
  //background: #d9534f;
  background: url("../../../assets/images/header.png") no-repeat center center;
  background-size: cover;
  height: 100%;
  padding-bottom: 40px;
  box-sizing: border-box;
  .left {
    color: #ffffff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .logo_wrap {
      padding-left: 16px;
      font-family: Source Han Sans SC;
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 28px;
      color: #FFFFFF;
      @media (min-width: 2160px) {
        font-size: 30px;
      }
      > img {
        margin-right: 8px;
      }
      > span {
        font-size: 28px;
        @media (min-width: 2160px) {
          font-size: 30px;
        }
      }
    }
  }
  /deep/.right {
    display: flex;
    display: -webkit-flex;
    display: -ms-flexbox;
    justify-content: flex-end;
    padding-right: 15px;
    color: #ffffff;
    .el-button{
      i{
        font-size: 18px;
        @media (min-width: 2160px) {
          font-size: 20px;
        }
      }
    }
    .size {
      margin-right: 10px;
      display: flex;
      align-items: center;
      .s {
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 18px;
        border: 1px solid #FFFFFF;
        margin-right: 10px;
        cursor: pointer;
      }
      .si {
        margin-right: 10px;
      }
    }
    .right-icon {
      cursor: pointer;
      margin-right: 10px;
      display: flex;
      align-items: center;
      img {
        margin-right: 3px;
      }
    }
    .el-tooltip,.el-tooltip:hover{
      padding: 0;
      background: none;
      border: 0;
      color: #FFFFFF;
    }
    .switchover,.switchover:hover{
      background: #0C5EA7;
      border: 1px solid #3489D4;
      height: fit-content;
      padding: 14px 18px;
      border-radius: 50px;
      margin: auto;
      margin-right: 10px;
      span{
        font-weight: bold;
        i{
          margin-left: 8px;
          transition: transform .3s;
        }
      }
    }
    .switchover:hover{
         span{
          i{
            transform: rotate(-180deg);
          }
        }
      }
    .right-left {
      display: flex;
      align-items: center;
      position: relative;
      margin-right: 10px;
      > i, img {
        padding-right: 5px;
        font-size: 18px;
        @media (min-width: 2160px) {
          font-size: 20px;
        }
      }
      > span {
        display: inline-block;
        max-width: 190px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
      .hover-realname {
        opacity: 0;
        transition: opacity 0.8s;
        color: #333333;
        background: #fff;
        position: absolute;
        top: 70%;
        width: 100%;
        z-index: 999;
        border-radius: 5px;
        line-height: 20px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        transform-origin: center bottom;
        word-break: break-all;
        display: flex;
        flex-direction: column;
        align-items: center;
        span{
          color: #666666;
          padding: 10px 5px;
          width: 100%;
          &:first-child{
            border-bottom: 1px solid #e6e6e6;
          }
        }
      }
    }
    .right-right {
      display: flex;
      align-items: center;
      cursor: pointer;
      > i {
        padding-right: 5px;
      }
    }
    .right-left:hover .hover-realname {
      opacity: 1;
      transition: opacity 0.8s;
    }
  }
}
.el-tooltip__popper.popper{
  border-color: #FFFFFF !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  padding: 5px 0 !important;
  .content{
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    span{
      color: #666666;
      padding: 10px 40px;
      cursor: pointer;
      &:first-child{
        border-bottom: 1px solid #e6e6e6;
      }
    }
    p{
      color: #666666;
      padding: 10px 40px;
      border-bottom: 1px solid #e6e6e6;
      cursor: pointer;
      &:last-child{
        border: 0;
      }
      &:hover{
        span{
          color: #0E70B5 !important;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper.popper{
  border-color: #FFFFFF !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  padding: 0 !important;
  top: 65px !important;
  .content{
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    span{
      color: #666666;
      padding: 10px 30px;
      cursor: pointer;
      &:first-child{
        border-bottom: 1px solid #e6e6e6;
      }
    }
    p{
      color: #FFFFFF;
      padding: 10px 30px;
      cursor: pointer;
      color: #666666;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      align-items: center;
      span{
        border: 0 !important;
        padding: 0 !important;
        color: #666666 !important;
      }
      &:hover{
        span{
          color: #0E70B5 !important;
        }
      }
      img{
        margin-right: 10px !important;
      }
      &:last-child{
        border: 0;
      }
    }
  }
}
.el-tooltip__popper.popper .popper__arrow {
  border: none;
  border-color: #FFFFFF !important;
  background: #FFFFFF !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  font-size: 18px;
  @media (min-width: 2160px) {
    font-size: 20px;
  }
}
</style>
<!-- css样式 end-->
